var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('AppBarPublic',{attrs:{"color":"primary100"}}),_c('v-main',{},[_c('transition',[_c('keep-alive',[_c('router-view')],1)],1)],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }